import { render } from "./SavingSubmission.vue?vue&type=template&id=61e5b9ef"
import script from "./SavingSubmission.vue?vue&type=script&lang=js"
export * from "./SavingSubmission.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__